import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import SingleSlider from '../../components/Slider';

import sliderImg1 from '../../assets/img/slider/slide-1-1.jpg';
import sliderImg2 from '../../assets/img/slider/slide-1-2.jpg';

const Hero = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '1',
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
  };

  return (
    <div className="it-slider-area it-slider-overley fix p-relative z-index">
      <div className="it-slider-wrap">
        <div className="swiper-container it-slider-active">
          <Swiper
            modules={[Navigation, EffectFade, Autoplay]}
            {...sliderOption}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide">
              <SingleSlider
                sliderImage={sliderImg1}
                title="Caring Hearts, Healing Hands Our Cardiology Practice"
                description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation.`}
                btnTextOne="Read More"
                btnTextTwo="Get in Touch"
              />
            </SwiperSlide>
            <SwiperSlide className="swiper-slide">
              <SingleSlider
                sliderImage={sliderImg2}
                title="Caring Hearts, Healing Hands Our Cardiology Practice"
                description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation.`}
                btnTextOne="Read More"
                btnTextTwo="Get in Touch"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Hero;
